// The session as React state: components re-render when the person signs in, switches location or signs out.
import { useSyncExternalStore } from 'react';
import { onSessionChange, sessionSnapshot } from './session.ts';

export function useSignedIn() {
  return useSyncExternalStore(onSessionChange, sessionSnapshot, sessionSnapshot);
}
